import React from 'react';
import PropTypes from 'prop-types';
import PanelComponent from '../../../components/stateful/PanelComponent';
import EditableRichText from '../../../../src/web/containers/EditableRichText';
import PlaceholderIcon from '../../../../modules/react/components/stateless/PlaceholderIcon';
import styles from './Accordion.scss';

const propTypes = {
  item: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  panelCloseStates: PropTypes.object.isRequired,
};

const defaultProps = {};

const AccordionItem = ({ item, onToggle, isEditing,
  onCancelEdit, panelCloseStates }) => (
  <div>
    <button type="button" onClick={onToggle} className={styles.toggleButton}>
      <span className={styles.titleContainer}>
        <span className={styles.accordionTitle}>{item.title.blocks[0].text}</span>
      </span>
      <PlaceholderIcon.DownChevron
        className={panelCloseStates[item.id] ? styles.rotateUp : styles.rotateDown}
        width="16"
        height="16"
        fill="#686868"
      />
    </button>
    <PanelComponent
      id={item.id}
      isExpanded={panelCloseStates[item.id]}
      panelClass={styles.customPanel}
      panelBodyClass={styles.customPanelBody}
      onToggle={onToggle}
    >
      <EditableRichText
        editorKey={`${item.id}-body`}
        editing={isEditing}
        rawContentState={item.body}
        onDismiss={onCancelEdit}
      />
    </PanelComponent>
    <hr />
  </div>
);

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;

export default AccordionItem;
